// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import '@fortawesome/fontawesome-pro/css/all.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'vue-jsondiffpatch/dist/formatters-styles/html.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import AlertCmp from './components/Shared/Alert.vue'
import IntersectionObserver from 'intersection-observer'
import VueObserveVisibility from 'vue-observe-visibility'
import VueTouch from 'vue-touch'
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
/* import wysiwyg from 'vue-wysiwyg' */
import './components/Shared/editor/css/vueWysiwyg.css'
import { store, WEBSOCKET_HOST } from './store'

import Echo from 'laravel-echo'
import VueEcho from 'vue-echo/vue-echo'

import LangFlag from 'vue-lang-code-flags'
import UUID from 'vue-uuid'
import vueHeadful from 'vue-headful'

/* import {library} from '@fortawesome/fontawesome-svg-core'

library.add(
    faCustomsIcon
) */

/* import VueSocketio from 'vue-socket.io'
Vue.use(VueSocketio, window.location.hostname + ':6001')

import Echo from 'laravel-echo'
import VueEcho from 'vue-echo'

import SocketIO from 'socket.io-client'
io: SocketIO(window.location.hostname + ':6001', {
    path: '/socket.io/'
})
*/

/* let token = document.head.querySelector('meta[name="token"]')
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
} */

Vue.use(UUID)

if (store.getters.getBearerToken !== null) {
  var echo = new Echo({
    broadcaster: 'socket.io',
    client: require('socket.io-client'),
    host: WEBSOCKET_HOST,
    auth: {
      headers: {
        Authorization: 'Bearer ' + store.getters.getBearerToken
      }
    }
  })
  Vue.use(VueEcho, echo)
}

Vue.component('app-alert', AlertCmp)

Vue.component('vue-headful', vueHeadful)

Vue.use(Vuetify, {
  theme: {
    primary: '#a69b2b',
    secondary: '#1e336d',
    accent: '#1e336d',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.use(VueObserveVisibility)
Vue.use(IntersectionObserver)
Vue.use(VueChartkick, { adapter: Chart })
/* Vue.use(wysiwyg, {
  maxHeight: '35vh'
}) */
Vue.component('lang-flag', LangFlag)
VueTouch.registerCustomEvent('doubletap', {
  type: 'tap',
  taps: 2
})
Vue.use(VueTouch, { name: 'v-touch' })
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js